import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames/bind';

const cx = classNames.bind();

const HeaderNowrap = styled.div`
  white-space: nowrap;
`;
const GriddleHeaderNowrap = ({ displayName, defaultSortIcon = false}) => {
    return (
        <HeaderNowrap className={cx({'grid-sort-default': defaultSortIcon})}>
            <span>
                {displayName}
            </span>
        </HeaderNowrap>
    );
};

GriddleHeaderNowrap.propTypes = {
    defaultSortIcon: PropTypes.bool,
    displayName: PropTypes.string,
};

export default GriddleHeaderNowrap;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/GriddleHeaderNowrap.js